export const MAX_READABLE_DECIMAL = 100_000_000_000;
export const MIN_BIRTH_DATE_STRING = '1900-01-01';
export const MAX_INPUT_TEXT_LENGTH = 255;
export const MAX_READABLE_INT = 1_000_000;
